import { useNavigate } from 'react-router-dom';
import { Wrench } from 'lucide-react';
import { motion } from 'framer-motion';

import { Button } from '../../../components/ui/button.tsx';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../../components/ui/card.tsx';

const Security = () => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.5,
        ease: 'easeInOut',
      }}
    >
      <div className="w-full">
        <Card className="md:h-[80vh] h-[60vh]  w-full flex flex-col items-center justify-center bg-white p-6">
          <CardHeader className="flex flex-col items-center space-y-2">
            <Wrench className="h-12 w-12 text-purple-600" />
            <CardTitle>This Page Is Under Construction</CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-4">
            <p className="text-gray-600">
              We’re busy building something awesome here. Check back soon!
            </p>
            <Button
              variant="outline"
              onClick={() => navigate(-1)}
              className="w-full"
            >
              Go Back
            </Button>
          </CardContent>
        </Card>
      </div>
    </motion.div>
  );
};

export default Security;
